import { Gtm } from "../apis/gtm";
import { isTrackingNumber } from "../utils/validations";

export class TrackingController {
  private static apiUrl =
    "https://n8n-production-3e8c.up.railway.app/webhook/track-number";

  private static showError = () => {
    window["spyGlass"].style.display = "none";
    window["error"].style.display = "inline-block";
    window["tnInput"].style.boxShadow = "0 7px 25px #FA3E3E";
  };

  private static removeError = () => {
    window["spyGlass"].style.display = "inline-block";
    window["error"].style.display = "none";
    window["tnInput"].style.boxShadow = "0 7px 25px rgba(22,53,76,.18)";
  };

  private static setLoading = (isLoading: boolean) => {
    window["loaderGif"].style.display = isLoading ? "flex" : "none";
    window["spyGlass"].style.display = isLoading ? "none" : "inline-block";
    window["trackingBtn"].style.disabled = isLoading;
    window["trackingBtn"].style.opacity = isLoading ? 0.6 : 1;
    if (isLoading) {
      window["trackingBtn"].classList.remove("primary-pulse");
    } else {
      window["trackingBtn"].classList.add("primary-pulse");
    }
  };

  private static handleClick = async () => {
    TrackingController.removeError();
    const input = window["trackingInput"] as HTMLInputElement;

    const tn = input.value.replace(/\W/g, '').toUpperCase();
    Gtm.trackParcelTracked(tn);
    const isTnValid = isTrackingNumber(tn);

    if (isTnValid) {
      input.value = tn;
      TrackingController.setLoading(true);
      const url = `${TrackingController.apiUrl}?tn=${tn}`;
      const res = await fetch(url);
      const html = await res.text();
      window["trackingInfo"].innerHTML = html;
      TrackingController.setLoading(false);

      if (res.ok) {
        Gtm.trackParcelTrackedSuccess(tn);
        window["trackingInfo"].classList.remove("e-tracking");
        window["trackingInfo"].classList.add("g-tracking");
      } else {
        Gtm.trackParcelTrackedError(tn);
        window["trackingInfo"].classList.remove("g-tracking");
        window["trackingInfo"].classList.add("e-tracking");
      }
      window["trackingInfo"].scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      TrackingController.showError();
    }
  };

  static init = () => {
    const button = window["trackingBtn"] as HTMLButtonElement;
    const input = window["trackingInput"] as HTMLInputElement;

    if (input) {
      input.addEventListener("focus", TrackingController.removeError);
    }

    if (button) {
      button.addEventListener("click", TrackingController.handleClick);
    }
  };
}
